/**
 * Tiny indirection over `window.location` so the popup-blocked full-page
 * fallback can be exercised in unit tests without real navigation.
 */
export const navigation = {
  currentHref(): string {
    return window.location.href;
  },
  navigate(url: string): void {
    window.location.href = url;
  },
};
